import { Controller } from "@hotwired/stimulus"

// Toggle entre "Proveedor de servicios" (sin desglose) y "Proveedor de productos" (con items).
// Cuando se marca el checkbox, oculta la sección de items y la columna Component.
//
// Connect: data-controller="service-provider-toggle"
// Checkbox: data-service-provider-toggle-target="checkbox" data-action="change->service-provider-toggle#sync"
// Sección items: data-service-provider-toggle-target="itemsSection"
// Banner servicios: data-service-provider-toggle-target="servicesBanner"
export default class extends Controller {
  static targets = ["checkbox", "itemsSection", "servicesBanner"]

  connect() {
    this.sync()
  }

  sync() {
    const isService = this.checkboxTarget.checked
    this.itemsSectionTargets.forEach(el => {
      el.classList.toggle("d-none", isService)
    })
    this.servicesBannerTargets.forEach(el => {
      el.classList.toggle("d-none", !isService)
    })
  }
}
